import { ResourceOptions } from 'react-admin';
import { FaCalendar } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.redpacketCampaignDates;
export const icon = FaCalendar;
export const options: ResourceOptions = {
  label: 'module.redpacket.campaignDates',
};
